import fetch from 'cross-fetch';
import { API_PATH } from '../contact_const';
import { getClientDate } from '../utilities';

export const SET_FORM = 'SET_FORM';

function setForm(form) {
  return {
    type: SET_FORM,
    form
  };
}

export const CLEAR_FORM = 'CLEAR_FORM';

export function clearForm() {
  return {
    type: CLEAR_FORM
  };
}

export const REQUEST_CONFIRM = 'REQUEST_CONFIRM';

function requestConfirm(form) {
  return {
    type: REQUEST_CONFIRM,
    request: true,
    form
  };
}

export const RECEIVE_CONFIRM = 'RECEIVE_CONFIRM';

function receiveConfirm(json) {
  return {
    type: RECEIVE_CONFIRM,
    errors: json.errors,
    status: json.result === 'ok',
    request: false,
    token: json.token
  };
}

export const BACK_INPUT_PAGE = 'BACK_INPUT_PAGE';

export function backInputPage() {
  return {
    type: BACK_INPUT_PAGE,
    request: false
  };
}

export const REQUEST_CONTACT = 'REQUEST_CONTACT';

export function requestContact() {
  return {
    type: REQUEST_CONTACT,
    request: true
  };
}

export const FINISH_CONTACT = 'FINISH_CONTACT';

export function finishContact(json) {
  return {
    type: FINISH_CONTACT,
    status: json.result === 'ok',
    request: false
  };
}

export const ERROR_GENERATED = 'ERROR_GENERATED';

export function errorGenerated() {
  return {
    type: ERROR_GENERATED
  };
}

export const FORM_INIT = 'FORM_INIT';

export function formInit(json) {
  return {
    type: FORM_INIT,
    form_settings: json
  };
}

export function getFormSetting() {
  return (dispatch) => {
    return fetch(API_PATH, {
      method: 'PUT',
      body: JSON.stringify({ type: 'form_setting' }),
      cache: "no-store",
      headers: {
        Accept: 'application/json'
      }
    }).then(response => response.json())
      .then(json => {
        return dispatch(formInit(json.form_settings));
      })
      .catch(() => dispatch(errorGenerated()));
  };
}

export function fetchConfirm(form) {
  return (dispatch) => {
    dispatch(setForm(form));
    dispatch(requestConfirm(form));

    return fetch(API_PATH, {
      method: 'POST',
      body: new FormData(form),
      headers: {
        Accept: 'application/json'
      }
    })
      .then(response => response.json())
      .then((json) => {
        dispatch(receiveConfirm(json));
      })
      .catch(() => dispatch(errorGenerated()));
  };
}

export function sendContact(token) {
  return (dispatch) => {
    dispatch(requestContact());
    return fetch(API_PATH, {
      method: 'PUT',
      body: JSON.stringify({
        token,
        client_datetime: getClientDate()
      })
    })
      .then(response => response.json())
      .then((json) => {
        if (json.result === 'ok') {
          return dispatch(finishContact(json));
        }
        throw new Error('error generated');
      })
      .catch(() => dispatch(errorGenerated()));
  };
}
